import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function WhatIs() {
  const { t } = useTranslation();

  return (
    <section className="relative bg-background-100 py-16 md:py-20">
      <div className="mx-auto grid w-full max-w-[1280px] items-center gap-10 px-4 md:px-6 lg:grid-cols-2">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("what.title")}
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base">{t("what.p1")}</p>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">{t("what.p2")}</p>
          <Link
            to="/usfans-spreadsheet-guide"
            className="mt-7 inline-flex items-center gap-2 rounded-full bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 whitespace-nowrap"
          >
            {t("what.cta")}
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>

        <div className="overflow-hidden rounded-lg border border-background-200">
          <img
            src="https://readdy.ai/api/search-image?query=A_bright_desk_scene_with_a_laptop_displaying_a_grid_of_fashion_category_cards_next_to_a_small_potted_plant_a_coffee_cup_and_a_wooden_desk_organizer_on_a_warm_oak_table_soft_morning_window_light_high_detail_editorial_photography_organized_cozy_fresh_aesthetic&width=800&height=600&seq=whatis-spreadsheet&orientation=landscape&nocache=true"
            alt="USFans Spreadsheet explained"
            className="h-full w-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}